import { useCallback, useEffect, useState, useRef } from 'react';
export default function useInterval(callback, interval, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$autoStart = _options.autoStart,
      autoStart = _options$autoStart === void 0 ? true : _options$autoStart;

  var _useState = useState(autoStart),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var start = useCallback(function () {
    return setIsActive(true);
  }, [setIsActive]);
  var stop = useCallback(function () {
    return setIsActive(false);
  }, [setIsActive]);
  var callbackRef = useRef();
  useEffect(function () {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(function () {
    function tick() {
      callbackRef.current();
    }

    if (isActive && !!interval) {
      var intervalId = setInterval(tick, interval);
      return function () {
        return clearInterval(intervalId);
      };
    }

    return function () {};
  }, [interval, isActive]);
  return {
    isActive: isActive,
    start: start,
    stop: stop
  };
}